import React, { useEffect, useState } from "react";
import { message, Popconfirm, Table } from "antd";
import SidebarHeaderLayout from "../../HOC/SidebarHeaderLayout";
import { Link } from "react-router-dom";
import {
  deleteArrivalMgmnt,
  deleteGuestlist,
  getAllArrivalMgmnt,
  getAllGuestlist,
} from "../../../api-core/Ghms";
import { formatDate } from "../../../utils/helper";

const ListOfArrivalMgmnt = () => {
  const [data, setdata] = useState([]);
  const [loading, setloading] = useState(false);
  useEffect(() => {
    fetchAllArrivalMgmnt();
  }, []);
  const fetchAllArrivalMgmnt = async () => {
    setloading(true);
    const res = await getAllArrivalMgmnt();
    setdata(res.ghmsarrivalmgmt);
    setloading(false);
  };
  const onDeleteRecord = async (record, id) => {
    const recordId = {
      ids: [record],
    };
    const res = await deleteArrivalMgmnt(recordId);
    if (res.success == true) {
      message.success(res.msgText);
      fetchAllArrivalMgmnt();
    }
  };

  const datas = data.map((item) => ({
    key: item._id,
    subEventTitle: item.sub_event_id.subevent_title,
    guestName: item?.guest_id?.guest_name,
    dateOfArrival: formatDate(item.date_of_arrival, "DD-MMM-YYYY"),
    noOfGuestArrived: item.no_of_guest_arrived,
    modeOfArrival: item.mode_of_arrival,
    expctArrivalTime: item.expected_arrival_time,
    arrivedAt: item.arrived_at,
    pickedBy: item.picked_by,
    vendorName: item.vendor_id.vendor_name,
    carName: item.car_id?.car_name,
    carModel: item.car_id?.car_model,
    carNumber: item.car_id?.car_number,
    driverName: item.driver_id.driver_name,
    welcomeChecklist: item.welcome_checklist,
    specialNote: item.special_note,
  }));
  // console.log("datas", datas);

  const columns = [
    {
      title: "Sr.",
      dataIndex: "number",
      key: "id",
      sorter: (a, b) => a.id - b.id,
      render: (id, record, index) => {
        ++index;
        return index;
      },
      showSorterTooltip: false,
    },
    {
      title: "Sub Event Title",
      dataIndex: "subEventTitle",
      key: "subEventTitle",
      ellipsis: true,
    },
    {
      title: "Guest Name",
      dataIndex: "guestName",
      key: "guestName",
      ellipsis: true,
    },

    {
      title: "Date of Arrival",
      dataIndex: "dateOfArrival",
      key: "dateOfArrival",
      ellipsis: true,
    },

    {
      title: "No of Guest Arrived",
      dataIndex: "noOfGuestArrived",
      key: "noOfGuestArrived",
      ellipsis: true,
    },

    {
      title: "Mode Of Arrival",
      dataIndex: "modeOfArrival",
      key: "modeOfArrival",
      ellipsis: true,
    },

    {
      title: "Expected Arrival Time",
      dataIndex: "expctArrivalTime",
      key: "expctArrivalTime",
      ellipsis: true,
    },

    {
      title: "Arrived At",
      dataIndex: "arrivedAt",
      key: "arrivedAt",
      ellipsis: true,
    },

    {
      title: "Picked By",
      dataIndex: "pickedBy",
      key: "pickedBy",
      ellipsis: true,
    },

    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      key: "vendorName",
      ellipsis: true,
    },

    {
      title: "Car Name",
      dataIndex: "carName",
      key: "carName",
      ellipsis: true,
    },
    {
      title: "Car Model",
      dataIndex: "carModel",
      key: "carModel",
      ellipsis: true,
    },
    {
      title: "Car Number",
      dataIndex: "carNumber",
      key: "carNumber",
      ellipsis: true,
    },
    {
      title: "Driver Name",
      dataIndex: "driverName",
      key: "driverName",
      ellipsis: true,
    },
    {
      title: "Welcome Checklist",
      dataIndex: "welcomeChecklist",
      key: "welcomeChecklist",
      ellipsis: true,
    },
    {
      title: "Special Note",
      dataIndex: "specialNote",
      key: "specialNote",
      ellipsis: true,
    },

    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <div className="flex gap-x-2 ">
          {/* {console.log("rec", record)} */}
          <Link to={`/admin/singlearrivalmgmnt/${record.key}`}>
            <button className="text-blue-600 cursor-pointer">View</button>
          </Link>

          <Link to={`/admin/updatearrivalmgmnt/${record.key}`}>
            <button className="text-yellow-400 cursor-pointer">Edit</button>
          </Link>

          <Popconfirm
            title="Sure to delete?"
            onConfirm={(e) => onDeleteRecord(record.key, e)}
          >
            <span className="text-red-500 cursor-pointer">Delete</span>
          </Popconfirm>
        </div>
      ),
    },
  ];
  return (
    <div className="">
      <Link to="/admin/createarrivalmgmnt">
        <button className="bg-blue-600 text-white p-3 mx-3">
          Create Arrival Mgmnt
        </button>
      </Link>
      <h1 className="text-center">List Of Guest List</h1>
      <div className="">
        <Table
          dataSource={datas}
          columns={columns}
          loading={loading}
          scroll={{
            y: "auto",
            x: "auto",
          }}
          // rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' :  'table-row-dark'}
        />
      </div>
    </div>
  );
};

export default SidebarHeaderLayout(ListOfArrivalMgmnt);
